import { FormikProps } from 'formik';

export enum AsyncValidationStatus {
  INIT = 'INIT',
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  VALID = 'VALID',
  INVALID = 'INVALID',
  ERRORED = 'ERRORED',
  ABORTED = 'ABORTED'
}

export interface AsyncValidationFormState<AsyncFormState extends object = object> {
  fields: { [key in keyof AsyncFormState]: AsyncValidationStatus };
  isValidating: boolean;
}

export interface AsyncValidationFormActions<AsyncFormState extends object = object> {
  setFieldStatus: <K extends keyof AsyncFormState>(
    fieldName: K,
    status: AsyncValidationStatus
  ) => void;
  registerAsyncField: <K extends keyof AsyncFormState>(fieldName: K) => void;
  runValidationsAndSubmit: (
    formikProps: FormikProps<unknown>,
    successCallback: (formikValues: unknown) => void,
    errorCallback?: (formikErrors: unknown) => void
  ) => void;
}

export type AsyncValidationFormContextState<AsyncFormState extends object = object> =
  AsyncValidationFormState<AsyncFormState> & AsyncValidationFormActions<AsyncFormState>;
